"use client";

import Header from "@/layout/headers/header";
import Wrapper from "@/layout/wrapper";
import Footer from "@/layout/footers/footer";
import { Suspense } from "react";
import Loading from "./loading";

export default function ReturnsAndRefundsPage() {
  return (
    <Wrapper>
      <Header />

      <main>
        <Suspense fallback={<Loading />}>
          <section
            style={{
              padding: "80px 16px",
              background: "#ffff",
            }}
          >
            <div className="container d-flex justify-content-center">

              <div className="policy-card">

                <h1 className="policy-title">
                  iMall Return & Refund Policy
                </h1>

                <p className="policy-sub">
                  Our simple and customer-friendly return and refund policy.
                </p>

                {/* RETURN POLICY */}
                <div className="policy-section">
                  <h4>🔄 Return Policy</h4>

                  <p>
                    Products are eligible for return within 
                    <strong> 7 days </strong>
                    from the delivery date under the following conditions:
                  </p>

                  <ol>
                    <li>The product is damaged or defective.</li>
                    <li>An incorrect size was delivered.</li>
                    <li>A wrong product was sent.</li>
                    <li>The product does not match the description or image.</li>
                    <li>The quantity delivered is missing or incorrect.</li>
                  </ol>

                  <p>
                    To request a return, please contact us with your
                    <strong> Order Number </strong>
                    and a clear explanation of the issue.
                  </p>

                  <div className="policy-alert warning">
                    ⚠️ When returning the parcel, clearly mention your 
                    <strong> Order Number </strong> and 
                    <strong> Return Tracking Number </strong> on the package.
                  </div>
                </div>

                <div className="policy-divider" />

                {/* REFUND POLICY */}
                <div className="policy-section">
                  <h4>💳 Refund Policy</h4>

                  <ol>
                    <li>Refunds are processed after return approval.</li>
                    <li>
                      Refunds will be completed within 
                      <strong> 7–10 business days</strong>.
                    </li>
                    <li>In many cases, refunds may be processed earlier.</li>
                  </ol>

                  <p>
                    If a return request is rejected after inspection, the product 
                    will be shipped back to the customer.
                  </p>

                  <div className="policy-alert danger">
                    ⚠️ If delivery attempts fail three times due to customer 
                    unavailability, no refund will be issued.
                  </div>
                </div>

              </div>

            </div>
          </section>
        </Suspense>
      </main>

      <Footer />

      <style jsx>{`
        .policy-card {
          max-width: 860px;
          background: #ffffff;
          padding: 50px 40px;
          border-radius: 18px;
          border: 1px solid rgba(255,122,0,0.15);
          box-shadow: 0 12px 36px rgba(0,0,0,.08);
          transition: .3s ease;
        }

        .policy-card:hover{
          transform: translateY(-3px);
        }

        .policy-title{
          text-align:center;
          font-size:36px;
          font-weight:800;
          letter-spacing:1.2px;
          background: linear-gradient(135deg,#ff7a00,#ff3d00,#ff9800);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom:8px;
        }

        .policy-sub{
          text-align:center;
          color:#666;
          margin-bottom:35px;
          font-size:14px;
        }

        .policy-section{
          margin-bottom:30px;
        }

        .policy-section h4{
          font-weight:700;
          margin-bottom:12px;
          color:#ff6a00;
        }

        .policy-section p{
          font-size:15px;
          color:#444;
          line-height:1.7;
          margin-bottom:12px;
        }

        .policy-section ol{
          padding-left:22px;
          margin-bottom:12px;
        }

        .policy-section li{
          font-size:15px;
          color:#333;
          margin-bottom:8px;
          line-height:1.7;
        }

        .policy-alert{
          margin-top:16px;
          padding:14px 18px;
          border-radius:12px;
          font-size:14px;
          line-height:1.6;
        }

        .policy-alert.warning{
          background: rgba(255,122,0,0.08);
          color:#d35400;
          border-left:4px solid #ff7a00;
        }

        .policy-alert.danger{
          background: rgba(231,76,60,0.08);
          color:#c0392b;
          border-left:4px solid #e74c3c;
        }

        .policy-divider{
          height:1px;
          background:#eee;
          margin:40px 0;
        }

        @media(max-width:576px){
          .policy-card{
            padding:28px 18px;
          }

          .policy-title{
            font-size:26px;
          }
        }
      `}</style>

    </Wrapper>
  );
}
